// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__KT6qL","container_video":"styles_container_video__Fhdef","video":"styles_video__I4e1l","container_content":"styles_container_content__qe4rc"};